import { JOURNEY_PHASES, HOLD } from '../../lib/journey.js'
import styles from './JourneyFunnel.module.css'

/** The high-level journey pipeline as clickable phase tiles (+ On hold). */
export default function JourneyFunnel({ counts, selected, onSelect }) {
  const total = Object.values(counts).reduce((a, b) => a + b, 0)
  const holdCount = counts[HOLD] || 0

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <div className={styles.title}>Order journey</div>
        <div className={styles.hint}>{total} account{total === 1 ? '' : 's'} in feed · click a phase to filter</div>
      </div>
      <div className={styles.funnel}>
        {JOURNEY_PHASES.map((p, i) => {
          const count = counts[p.key] || 0
          const active = selected === p.key
          return (
            <button
              key={p.key}
              type="button"
              className={`${styles.stage} ${active ? styles.active : ''} ${count ? '' : styles.empty}`}
              data-tone={p.tone}
              onClick={() => onSelect(active ? null : p.key)}
              aria-pressed={active}
            >
              <span className={styles.stageIndex}>{i + 1}</span>
              <span className={styles.stageCount}>{count}</span>
              <span className={styles.stageLabel}>{p.label}</span>
              <span className={styles.stageBlurb}>{p.blurb}</span>
            </button>
          )
        })}
      </div>
      {holdCount > 0 && (
        <div className={styles.offRow}>
          <button
            type="button"
            className={`${styles.chip} ${selected === HOLD ? styles.chipActive : ''}`}
            data-tone="danger"
            onClick={() => onSelect(selected === HOLD ? null : HOLD)}
            aria-pressed={selected === HOLD}
          >
            <span className={styles.chipDot} /> On hold / lost <span className={styles.chipCount}>{holdCount}</span>
          </button>
        </div>
      )}
    </div>
  )
}

